import * as React from "react";
import { useState, useEffect } from "react";
import { Badge } from "@fluentui/react-components";
import { getOffersByUser } from "../services/AuctionService";
import { IBestOffer } from "../models/offer";
import { IProfile } from "../models/profile";
import { format } from "date-fns";

export interface IProfileProps {
    user: IProfile;
}

export const Profile = (props: IProfileProps) => {  
  const [offers, setOffers] = useState<IBestOffer[]>([]);
  const { user } = props;
  
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const result = await getOffersByUser();
      console.log(result);
      setOffers(result);
    };
    fetchData().catch(console.error)
  }, []);

  return (
    <div className="container">      
      <div className="page-title">PROFILO UTENTE</div>
      <div className="infobox">
        <div className="row mb-1">
          <div className="col-2">Email</div>
          <div className="col-10 textbold">{user.username}</div>
        </div>
        <div className="row mb-1">
          <div className="col-2">Nome visualizzato</div>
          <div className="col-10 textbold">{user.displayname}</div>
        </div>
      </div> 
      <div className="page-title">OFFERTE EFFETTUATE</div>
      {
          offers.map((offer: IBestOffer) => {
            return (
              <>
                <div key={offer.AuctionID} className="row">
                  <div className="col-2 team">
                    <img src={`${process.env.PUBLIC_URL}/img/${offer.Team}.png`} style={{ width: "30px" }} />
                    <div className=" jersey">{offer.JerseyNumber!.padStart(2, '0')}</div>
                  </div>                
                  <div className="col-7 fullname" style={{fontSize:"12pt"}}>{offer.Fullname}</div>
                  <div className="col-3 price">{offer.Price}€</div>
                </div>
                <div className="col-12" style={{fontSize:'8px', textAlign:'right'}}>
                  {format(offer.AuctionData, "dd/MM/yyyy HH:mm:ss")}
                </div>
              </>
            )})
        }     
{/* 
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Squadra</th>
            <th scope="col">Nome</th>
            <th scope="col">Data</th>
            <th scope="col">Offerta</th>
          </tr>
        </thead>
        <tbody>
          {
            offers.map((offer: IBestOffer) => {
              return (
                <tr key={offer.OfferID} className="offerRow">
                  <td>{offer.JerseyNumber}</td>
                  <td>{offer.Team}</td>
                  <td>{offer.Fullname}</td>
                  <td width={200}>{format(offer.AuctionData, "dd/MM/yyyy HH:mm")}</td>
                  <td width={50}>€ {offer.Price}</td>
                </tr>
              );
            })
          }
        </tbody>
      </table>   
*/}
      
    </div>
  );
};